
// This function helps us notify a webview of the user's token.
// It is used in parts of the code that also power our mobile app signup flow.
// Modifying this function should be done with caution, and chattermobile
// should be tested to ensure the signup flow still works.

export const postMessageToWebView = (type: string, payload: any | null) => {
  try {
    // @ts-expect-error
    if (window.ReactNativeWebView) {
        // @ts-expect-error
        // Property 'ReactNativeWebView' does not exist on type 'Window & typeof globalThis'
        window.ReactNativeWebView.postMessage(JSON.stringify({ type, payload }))
      } else {
        // fallback for outdated browsers
        window.postMessage(JSON.stringify({ type, payload }), '*')
      }
    } catch (e) {
      console.warn(
        'window.ReactNativeWebView is not valid, cannot send message',
        e
      )
    }
  }
